// Firebase client SDK initialization for HalalGifHampers.
// Config comes from REACT_APP_FIREBASE_* env vars (see frontend/.env).
// Exposes Firestore (db), Auth, and Storage singletons plus lazy Analytics.
import { initializeApp } from "firebase/app";
// NOTE: the LITE Firestore SDK — ~870 KB smaller than the full build and it
// also drops the re2js dependency. Safe here because nothing uses realtime
// listeners (onSnapshot), transactions, or offline persistence. If you ever
// need onSnapshot, all four importers must move back to "firebase/firestore"
// together — mixing lite and full ships both SDKs and breaks at runtime.
import { getFirestore } from "firebase/firestore/lite";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
// Cloud Functions live in the same region as Firestore.
export const functions = getFunctions(app, "asia-southeast1");

// Analytics only initializes in supported browser environments.
export let analytics = null;
isSupported()
  .then((supported) => {
    if (supported && firebaseConfig.measurementId) analytics = getAnalytics(app);
  })
  .catch(() => {});

export default app;
